/* tslint:disable */
/* eslint-disable */
/**
 * ClimatePartner API Calculation Service
 * A Unified API for all ClimatePartner products
 *
 * The version of the OpenAPI document: 1.6.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



export interface CommonErrorGatewayTimeoutError {
    'code': CommonErrorGatewayTimeoutErrorCodeEnum;
    'message': string;
}

export enum CommonErrorGatewayTimeoutErrorCodeEnum {
    IntegrationTimeout = 'INTEGRATION_TIMEOUT'
}


